<template>
  <div class="ems-page case-feedback-settings-page" data-test-id="case-feedback-settings">
    <NavBar>
      <template #left>
        <div class="text-red" @click="onBackButtonClick">Back</div>
      </template>
      <template #center>
        <span>
          <b>Case Feedback</b>
        </span>
      </template>
    </NavBar>
    <b-container class="mt-4">
      <b-row>
        <b-col class="mb-4">
          <b-button
            block
            class="do-not-disturb-button"
            variant="light"
            data-test-id="do-not-disturb-button"
            @click="doNotDisturbClicked"
          >
            <div class="">Do Not Disturb</div>
            <div class="do-not-disturb-button__switch" @click.stop="() => {}">
              <b-form-checkbox :checked="shouldNotDisturb" switch @change="doNotDisturbClicked" />
            </div>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-4">
          <b-button
            id="save-feedback-settings-button"
            data-cy-save-feedback-settings-button
            variant="danger"
            block
            class="mt-5 mb-5"
            :disabled="!isSaveButtonEnabled"
            @click.prevent="onSaveButtonClick"
            >Save</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/App/components/NavBar.vue";

export default {
  name: "CaseFeedbackSettings",
  components: { NavBar },
  computed: {
    ...mapGetters("CaseFeedbackSettings", ["isSaveButtonEnabled", "shouldNotDisturb"]),
  },
  mounted() {
    this.$store.dispatch("CaseFeedbackSettings/onViewLoaded");
  },
  methods: {
    ...mapActions("CaseFeedbackSettings", ["onSaveButtonClick", "doNotDisturbClicked", "onBackButtonClick"]),
  },
};
</script>

<style scoped>
.case-feedback-settings-page {
  text-align: left;
}

.do-not-disturb-button {
  display: flex;
}

.do-not-disturb-button__switch {
  margin-left: auto;
}
</style>
